<template>
    <div class="staff">
        <div class="header-box">
            <el-button type="primary" @click="addFn('add')">新增</el-button>
        </div>
        <el-table
            :data="tableData"
            style="width: 100%"
            border>
            <el-table-column type="index" width="50" align="center" label="序号"></el-table-column>
            <el-table-column prop="DialogName" label="弹窗名称" align="center"></el-table-column>
            <el-table-column prop="DialogType" label="弹窗类型" align="center">
                <template slot-scope="scope">
                    {{scope.row.DialogType==1?'活动弹窗':'默认弹窗'}}
                </template>
            </el-table-column>
            <el-table-column prop="ShowCount" label="弹出次数" align="center"></el-table-column>
            <el-table-column prop="MainButtonClickCount" label="主按钮点击次数" align="center"></el-table-column>
            <el-table-column prop="SubButtonClickCount" label="次按钮点击次数" align="center"></el-table-column>
            <el-table-column prop="IsShow" label="是否显示" align="center">
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.IsShow"
                        @change="changeIsShow(scope.row)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" align="center"></el-table-column>
            <el-table-column prop="UpdateTime" label="最后修改时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" @click="addFn('edit',scope.row)">
                        编辑
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="footer-box">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagin.pageIndex"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagin.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagin.TotalNumber">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tableData:[],
            pagin:{
                pageSize:10,
                pageIndex:1,
                TotalNumber:0
            }
        }
    },
    created() {
        this.getList();
    },
    methods: {
        handleSizeChange(val) {
            this.pagin.pageSize=val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.pagin.pageIndex=val;
            this.getList();
        },
        // 新增或编辑
        addFn(type,obj) {
            let query={};
            if(type=='edit') {
                query.Id=obj.Id;
            }
            this.$router.push({
                path:"/LoginDialogAdd",
                query:query
            });
        },
        // 获取列表
        getList() {
            this.$get(this.$api.GetDialogList,{
                ...this.pagin,
            }).then(res=>{
                this.tableData=res.Data;
                this.pagin.TotalNumber=res.TotalNumber;
            })
        },
        // 是否显示
        changeIsShow(obj) {
            this.$post(this.$api.SetDialogIsShow,null,{
                Id:obj.Id
            }).then(res=>{
                this.getList();
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
.staff {
    background: #fff;
    padding: 10px 10px;
    .header-box {
        margin-bottom:20px;
    }
    .footer-box {
        margin-top: 10px;
    }
}
</style>